export default { 
  FILLED_MODULE_FIELD: (state, { field }) => state.fields[field] = true,
  NOT_FILLED_MODULE_FIELD: (state, { field }) => state.fields[field] = false,
  INCREMENT_CURRENT_PROGRESS: (state, { progress }) => state.progress.current += progress,
  DECREMENT_CURRENT_PROGRESS: (state, { progress }) => state.progress.current -= progress,
}